var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',[_vm._v(_vm._s(_vm.$t('webpagesPublishers')))]),_c('StatFilters'),_c('StatResults')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }